import { publicComponentOption } from "dependencies/base"
import { toSelectOpt } from "utils"
const optDes = {
  imgSrc: "动画地址",
  ...publicComponentOption
}
export const getOptDes = toSelectOpt.bind(this, optDes)
